const icon = require('./icons/leave-house-100.png')

export const OutOfRoomIcon = () => {
  return <img src={icon} alt="out of room icon" className="w-full h-full"/>
}
